import React from "react";
import "./footer.css";

import EmailIcon from "@mui/icons-material/Email";
import CallIcon from "@mui/icons-material/Call";

const Footer = () => {
  return (
    <div className="footer">
      <div className="links-container">
        <div id="links">
          <h1>Website links</h1>
          <ul>
            <li>
              <a href="https://www.linkedin.com/in/rehan-ankalgi-84466619a/">
                about me
              </a>
            </li>
            <li>
              <a href="https://twitter.com/RehanAnkalgi">Services</a>
            </li>
          </ul>
        </div>
        <br />
        <div id="socials">
          <h1>Find me on social media</h1>
          <ul>
            <li>
              <a href="https://www.linkedin.com/in/rehan-ankalgi-84466619a/">
                Linkedin
              </a>
            </li>
            <li>
              <a href="https://twitter.com/RehanAnkalgi">Twitter</a>
            </li>
            <li>
              <a href="https://www.instagram.com/reho.design/">Instagram</a>
            </li>
            <li>
              <a href="https://medium.com/@rehanankalgi7t2">Medium</a>
            </li>
            <li>
              <a href="https://dribbble.com/rehan_ankalgi">Dribbble</a>
            </li>
            <li>
              <a href="https://github.com/rehan-ankalgi-7t2">Github</a>
            </li>
          </ul>
        </div>
        <br />
        <br />
        <div id="contact">
          <h1>Contact Details</h1>
          <p>
            <EmailIcon />
            creative.reho@gmail.com
          </p>
          <p>
            <CallIcon /> +91 9741120672
          </p>
        </div>
      </div>

      <span>Made with style ⚡ by Reho.</span>
    </div>
  );
};

export default Footer;
